import React from "react"
import { CompaniesContextType } from "./types"
export const CompaniesContext = React.createContext({} as CompaniesContextType)